import { Col, Row } from "react-grid-system";
import styled from "styled-components";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import colors from "../../assets/colors/colors";
import FullScreen from "./FullScreen";
import Card from "./Card";
import { useEffect, useState } from "react";
import { HiOutlineArrowsExpand } from "react-icons/hi";

interface Props {
  menu: {
    name: string;
    description: string;
    items: any;
  };
  id_restaurant: any;
  colors?: any;
}

interface StyledInterface {
  color: any;
  image: string;
}

interface InterfaceSection {
  color: any;
  image: string;
}

export default function ListCategories(props: Props) {
  const { name: sectionName, items: menus } = props.menu;

  const [openSection, setOpenSection] = useState<any>(false);
  const [previewSection, setPreview] = useState([]);

  const [imagePreview, setImagePreview] = useState<any>("");

  useEffect(() => {
    preview();
  }, []);

  const handleOpenSection = () => {
    let open = openSection;
    setOpenSection((open = !open));
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "initial";
    }
  };

  const closeFullScreen = () => {
    setOpenSection(false);
    document.body.style.overflow = "initial";
  };

  const preview = () => {
    // if (menus[0].image) {
    //   setImagePreview(menus[0].image);
    // }
  };

  return (
    <>
      {props.colors ? (
        <ContentCustom
          color={props.colors}
          onClick={() => handleOpenSection()}
          image={imagePreview}
        >
          {/* <div className="back"></div> */}
          <SectionMenu color={props.colors} image={imagePreview}>
            <Row align="center">
              <Col>
                <h4> {sectionName} </h4>
                <ul>
                  {previewSection.map((item: any, index: any) => (
                    <li>{item.name}...</li>
                  ))}
                </ul>
              </Col>
              <Col xs={2} className="text-center">
                <BsFillArrowRightCircleFill className="icon" />
              </Col>
            </Row>
          </SectionMenu>
        </ContentCustom>
      ) : (
        <Content
          color={colors}
          onClick={() => handleOpenSection()}
          image={imagePreview}
        >
          <section>
            <Row align="center">
              <Col>
                <h4> {sectionName} </h4>
                <ul>
                  {previewSection.map((item: any, index: any) => (
                    <li>{item.name}...</li>
                  ))}
                </ul>
              </Col>
              <Col xs={2} className="text-center">
                <BsFillArrowRightCircleFill className="icon" />
              </Col>
            </Row>
          </section>
        </Content>
      )}
      {openSection && (
        <div>
          <FullScreen
            data={menus}
            name={sectionName}
            closeFullScreen={closeFullScreen}
            id_restaurant={props.id_restaurant}
          />
        </div>
      )}
    </>
  );
}

const ContentCustom = styled.div<StyledInterface>`
  padding: 0.2em 1em;
  /* padding-left: ${(props) => (props.image ? "7em" : "1em")}; */
  padding-left: 1em;
  background-color: white;
  /* box-shadow: 0px 1px 2px #00000025; */
  /* border-radius: 12px; */
  margin: 1.5em 1em;
  border-bottom: 1px solid #00000025;
  position: relative;
  .back {
    background: url(${(props) => props.image});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    position: absolute;
    top: 0;
    left: 0;
    width: 30%;
    height: 100%;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }
  section {
    position: relative;
    padding: 1.4em 0;
    ul {
      position: absolute;
      left: 0;
      list-style: none;
      margin: 0 !important;
      padding: 0 1em !important;
      display: flex;
      flex-direction: row;
      white-space: pre;
      li {
        white-space: pre;
        margin: 0 0.2em;
        color: white;
      }
    }
    h4 {
      margin: 0 !important;
    }
    .icon {
      font-size: 1.5em;
      color: ${(props) => props.color.colors2};
    }
  }
`;

const SectionMenu = styled.section<InterfaceSection>`
  position: relative;
  padding: 2em 0;
  padding-left: 5em;
  ul {
    position: absolute;
    left: 0;
    list-style: none;
    margin: 0 !important;
    padding: 0 1em !important;
    display: flex;
    flex-direction: row;
    white-space: pre;
    li {
      white-space: pre;
      margin: 0 0.2em;
      color: #31313157;
    }
  }
  h4 {
    margin: 0 !important;
  }
  .icon {
    font-size: 1.5em;
    color: ${(props) => props.color.blue};
  }
`;
const Content = styled.div<StyledInterface>`
  padding: 0.5em 1em;
  padding-left: 1em;
  background-color: white;
  margin: 1.5em 1em;
  border-bottom: 1px solid #00000025;
  position: relative;
  section {
    position: relative;
    padding: 1.4em 0;
    ul {
      position: absolute;
      left: 0;
      list-style: none;
      margin: 0 !important;
      padding: 0 1em !important;
      display: flex;
      flex-direction: row;
      white-space: pre;
      li {
        white-space: pre;
        margin: 0 0.2em;
        color: #31313157;
      }
    }
    h4 {
      margin: 0 !important;
    }
    .icon {
      font-size: 1.5em;
      color: ${(props) => props.color.blue};
    }
  }
`;
